import React from "react";

export default function TravellersDropdown() {
  return (
    <div className="travellers--class travellers--guests" onClick={(e) => e.stopPropagation()}>
      {["Rooms", "Adults (above 18 yrs)", "Children (0 - 17 yrs)"].map((label, idx) => (
        <div className="tc--adults--row" key={idx}>
          <div className="tc--adults--label">{label}</div>
          <div className="tc--addcounter">
            <div className="tc--co-minus">-</div>
            <div className="tc--co-counter">3</div> 
            <div className="tc--co-plus">+</div> 
          </div>
        </div>
      ))}
      <div className="bg--tc--adults--row">
        <ul className="child--row--list">
          {[1, 2].map((num) => (
            <li key={num}>
              <label>Age of Child {num}</label>
              <select defaultValue="2">
                <option value="">Choose</option>
                {[1, 2, 3, 4, 5].map(v => <option key={v} value={v}>{v}</option>)}
              </select>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}